"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _localizedFormat = _interopRequireDefault(require("dayjs/plugin/localizedFormat"));

var _localeData = _interopRequireDefault(require("dayjs/plugin/localeData"));

var _relativeTime = _interopRequireDefault(require("dayjs/plugin/relativeTime"));

var _isSameOrBefore = _interopRequireDefault(require("dayjs/plugin/isSameOrBefore"));

var _advancedFormat = _interopRequireDefault(require("dayjs/plugin/advancedFormat"));

require("dayjs/locale/ar");

require("dayjs/locale/bg");

require("dayjs/locale/cs");

require("dayjs/locale/da");

require("dayjs/locale/de");

require("dayjs/locale/el");

require("dayjs/locale/en");

require("dayjs/locale/es");

require("dayjs/locale/fi");

require("dayjs/locale/fr");

require("dayjs/locale/he");

require("dayjs/locale/hi");

require("dayjs/locale/hu");

require("dayjs/locale/id");

require("dayjs/locale/it");

require("dayjs/locale/ja");

require("dayjs/locale/ko");

require("dayjs/locale/ms");

require("dayjs/locale/nl");

require("dayjs/locale/nb");

require("dayjs/locale/pl");

require("dayjs/locale/pt");

require("dayjs/locale/ro");

require("dayjs/locale/ru");

require("dayjs/locale/sv");

require("dayjs/locale/th");

require("dayjs/locale/tl-ph");

require("dayjs/locale/tr");

require("dayjs/locale/uk");

require("dayjs/locale/zh-tw");

require("dayjs/locale/zh-cn");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

if (!_dayjs["default"]._isExtended) {
  _dayjs["default"].extend(_localizedFormat["default"]);

  _dayjs["default"].extend(_localeData["default"]);

  _dayjs["default"].extend(_relativeTime["default"]);

  _dayjs["default"].extend(_isSameOrBefore["default"]);

  _dayjs["default"].extend(_advancedFormat["default"]);

  _dayjs["default"]._isExtended = true;
}

var _default = _dayjs["default"];
exports["default"] = _default;